// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1kFaT","title":"Header_title__13AUh","side":"Header_side__s7Drw"};